const SMPQuestDefaultStrategy = require("@/quest-editor/questImpl/strategies/SMPQuestDefaultStrategy");
const {N_GAMELEVEL_PER_QUEST_COMPLETE} = require("@/quest-editor/constants/GameConstant");
class SMPQuestCompleteNQuestStrategy extends SMPQuestDefaultStrategy {

     initStartingValue() {
          this._challengeList = [20, 5, 15, 10, 8, 15, 20, 25, 30, 40, 25];
     }

     increaseKPIGameplayReference() {
          this.questContext.KPIGameplayBossLevel += this.questContext.JumpingLevel;
     }

     computeChallenge() {
          this.questContext.challengeTarget = this.getTargetBaseOnLevel(this.questContext.level);
     }

     computeLevelShouldAppear() {
          let shouldAppearAt = this.questContext.KPIGameplayBossLevel - this.questContext.challengeTarget * N_GAMELEVEL_PER_QUEST_COMPLETE;
          if (shouldAppearAt < 1) shouldAppearAt = 1;
          this.questContext.KPIGameLevelShouldAppear = shouldAppearAt;
     }
}

module.exports = SMPQuestCompleteNQuestStrategy;